<template>
  <div class="about">
    <Header/>
    <div class="body">
      <div class="sobre">
        <h2 id='galeria'><font-awesome-icon icon="camera-retro" class="icon_spot"/> Galeria </h2>
        <h5 class="galeria_titulo">Tv cultura no Sapiência</h5>
        <p style="text-align:left!important;">Em fevereiro de 2019, a TV CULTURA foi até o Cursinho Sapiência para fazer uma reportagem que tinha como objetivo entender qual era o segredo para termos tido MAIS DE 10 APROVAÇÕES EM MEDICINA PÚBLICA naquele ano. Sabe qual é o nosso segredo? Ser uma família que te acompanha do início ao fim!!</p>
        <div class="galeria1">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="sala_estudo1" src="../assets/galeria/tv_cultura1.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="sala_estudo2" src="../assets/galeria/tv_cultura2.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="sala_estudo3" src="../assets/galeria/tv_cultura3.jpg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/tv_cultura1.jpg" class="img_grande" id="img_first1"/>
            </div>
        </div>
        <h5 class="galeria_titulo">Salas de Aula</h5>
        <div class="galeria2">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="saladeaula1" src="../assets/galeria/galeria_salas_de_aula (1).jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="saladeaula2" src="../assets/galeria/galeria_salas_de_aula (2).jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="saladeaula3" src="../assets/galeria/galeria_salas_de_aula (3).jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="saladeaula4" src="../assets/galeria/galeria_salas_de_aula (4).jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="saladeaula5" src="../assets/galeria/galeria_salas_de_aula (5).jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="saladeaula6" src="../assets/galeria/galeria_salas_de_aula (6).jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="saladeaula7" src="../assets/galeria/galeria_salas_de_aula (7).jpeg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/galeria_salas_de_aula (1).jpeg" class="img_grande" id="img_first_sala_de_aula"/>
            </div>
        </div>
        <h5 class="galeria_titulo">Aula de Taekwondo: para relaxar antes do ENEM!!</h5>
        <div class="galeria2">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="taekwondo1" src="../assets/galeria/taekwondo1.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="taekwondo2" src="../assets/galeria/taekwondo2.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="taekwondo3" src="../assets/galeria/taekwondo3.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="taekwondo4" src="../assets/galeria/taekwondo4.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="taekwondo5" src="../assets/galeria/taekwondo5.jpg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/taekwondo1.jpg" class="img_grande" id="img_first2"/>
            </div>
        </div>
        <h5 class="galeria_titulo">Descida estrada velha de Santos</h5>
        <div class="galeria3">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="estrada_velha1" src="../assets/galeria/estrada_velha1.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="estrada_velha2" src="../assets/galeria/estrada_velha2.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="estrada_velha4" src="../assets/galeria/estrada_velha4.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="estrada_velha4" src="../assets/galeria/estrada_velha5.jpg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/estrada_velha2.jpg" class="img_grande" id="img_first3"/>
            </div>
        </div>
        <h5 class="galeria_titulo">Revisão ENEM</h5>
        <div class="galeria4">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="revisao" src="../assets/galeria/revisao.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="revisao2" src="../assets/galeria/revisao2.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="revisao3" src="../assets/galeria/revisao3.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="revisao4" src="../assets/galeria/revisao4.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="revisao5" src="../assets/galeria/revisao5.jpg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/revisao.jpg" class="img_grande" id="img_first4"/>
            </div>
        </div>
        <h5 class="galeria_titulo">Realidade Virtual</h5>
        <div class="galeria5">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="vr1" src="../assets/galeria/vr1.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="vr2" src="../assets/galeria/vr2.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="vr3" src="../assets/galeria/vr3.jpg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/vr1.jpg" class="img_grande" id="img_first5"/>
            </div>
        </div>
        <h5 class="galeria_titulo">MASP 2019</h5>
        <div class="galeria6">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="maps1" src="../assets/galeria/maps1.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="maps2" src="../assets/galeria/maps2.jpg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="maps3" src="../assets/galeria/maps3.jpg" v-on:click="mudar($event)">
            </div>
            <div class="img_first">
              <img src="../assets/galeria/maps1.jpg" class="img_grande" id="img_first6"/>
            </div>
        </div>
        <h5 class="galeria_titulo">AULAS PBL</h5>
        <div class="galeria7">
            <div class="galeria_itens">
              <img alt="aprovados" class="img_galeria" id="plb1" src="../assets/galeria/plb1.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb2" src="../assets/galeria/plb2.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb3" src="../assets/galeria/plb3.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb4" src="../assets/galeria/plb4.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb5" src="../assets/galeria/plb5.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb6" src="../assets/galeria/plb6.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb7" src="../assets/galeria/plb7.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb8" src="../assets/galeria/plb8.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb9" src="../assets/galeria/plb9.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb10" src="../assets/galeria/plb10.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb11" src="../assets/galeria/plb11.png" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb12" src="../assets/galeria/rapha.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb13" src="../assets/galeria/bianca.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb14" src="../assets/galeria/artur.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb15" src="../assets/galeria/pig.jpeg" v-on:click="mudar($event)">
              <img alt="aprovados" class="img_galeria" id="plb16" src="../assets/galeria/adilson.jpeg" v-on:click="mudar($event)">

            </div>
            <div class="img_first">
              <img src="../assets/galeria/plb1.jpeg" class="img_grande" id="img_first7"/>
            </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
var img_full=false
export default{
  data(){
    return {
      'fullWidthImage': false,
      img_first1: '',
      img_first2: '',
      img_first3: '',
      img_first4: '',
    }
  },
  methods:{
      mudar(e){
        let caminho = e.path[0].src
        // console.log(e.path[2].childNodes[1].childNodes)
        document.getElementById(e.path[2].childNodes[1].childNodes[0].id).src = e.path[0].src;
        document.getElementById(e.path[2].childNodes[1].childNodes[0].id).style.display = "flex";
        // let div = e.path[2].childNodes[1].id
        // console.log(div)
        // console.log(caminho)


        // this.img_first1 = caminho

        // let id=e.currentTarget.id;
        // console.log(id)
        // if(img_full != true){
        //   var imagem = document.getElementById(id);
        //   imagem.style.width = '100%';
        //   img_full=true;
        // }
        // else if(img_full == true){
        //   var imagem = document.getElementById(id);
        //   imagem.style.width = '20%';
        //   img_full=false;
        // }
      }
  },
  components:{
    Header,
    Footer
  }
}
</script>

<style>
  #galeria:after {
   content: '';
   display: block;
   height: 2px;
   width: 60px;
   margin: 20px auto 0;
   background: purple;
  }
  @import "../assets/style_padrao.css";
  .galeria::-webkit-scrollbar-thumb {
    background: purple;
    border-radius: 5px;
  }
  .galeria_itens {
    display: inline-flex;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    margin: auto;
  }
  .galeria_titulo {
    width: fit-content;
    width: -moz-fit-content;
    background: #7435af;
    margin-left: -48px;
    padding: 20px;
    padding-left: 110px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    color: white;
    margin-top: 60px;
  }
  .full {
    width: 80%;
    height: auto;
  }
  .img_galeria {
    /* height: 20%; */
    width: auto;
    height: 200px;
    border-radius: 2px;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);
    transition: width 1s;
    margin-right: 5%;
  }
  .img_grande{
    display: none;
    width: 50%;
    border-radius: 2px;
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);
    transition: width 1s;
  }
  .img_galeria:hover {
    cursor: pointer;
  }
  .img_first{
    justify-content: center;
    display: flex;
  }
  @media only screen and (max-width: 450px) {
    .img_grande{
      width: 100%;
    }
  }
</style>
